





















import { Prop, Component, Vue } from 'vue-property-decorator'
import Checkbox from '../BaseCheckbox.vue'
import Address from '../BaseAddress.vue'
import Button from '../BaseButton.vue'
import Card from '../BaseCard.vue'
import CardContent from '../BaseCardContent.vue'
import Instructions from '../BaseInstructions.vue'
import { State, Mutation, namespace } from 'vuex-class'

const cart = namespace('cart')
const user = namespace('user')

@Component({
  components: { Button, Card, CardContent, Checkbox, Address, Instructions }
})
export default class BillingInfo extends Vue {
  @cart.State((state: any) => state.billing.address) address: Address
  @cart.State billingSameAsShipping: boolean
  @cart.State useStoredBillingInfo: boolean
  @user.State((state: any) => state.shipping.address) userBilling: Address
  @cart.Mutation replaceBillingAddress: any
  @cart.Mutation setAddress: any
  @cart.Mutation setBillingSameAsShipping: () => void
  @cart.Mutation editStoredShippingAddress: () => void

  updateAddress ($event: FormInputEvent) {
    this.setAddress({
      location: 'billing',
      field: $event.name,
      value: $event.value,
    })
  }
}
